import "./CameraInspection.module.css";
import EnTTe from "@/reusable_sections/Header";
import InspectionParCamRaHd from "./sections/InspectionParCamRaHd";
import AvantagesDeLInspection from "./sections/AvantagesDeLInspection";
import RServerUneInspection from "./sections/RServerUneInspection";
import PiedDePage from "@/reusable_sections/Footer";
export default function CameraInspectionPage() {
  return <div>
      <EnTTe />
      <InspectionParCamRaHd />
      <AvantagesDeLInspection />
      <RServerUneInspection />
      <PiedDePage />
    </div>;
}